import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BannerType } from '../../../../enum/builk/banner/banner-type.enum';
import { BannerFetchData, BannerModel } from '../../../../model/builk/banner-list/BannerFetchData.model';
import { BannerListService } from '../../../../service/api/builk/banner-list.service';

@Component({
  selector: 'app-Modals',
  templateUrl: './Modals.component.html',
  styleUrls: ['./Modals.component.scss']
})
export class ModalsComponent implements OnInit {

  constructor(
    private modalService: BsModalService,
    private BannerService: BannerListService
  ) {
    this.formBanners = new FormGroup({
      'name': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'imgDesktop': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'imgMobile': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'action': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'type': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'page': new FormControl(null, [Validators.required, Validators.nullValidator])
    });
    this.formEditBanners = new FormGroup({
      'name': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'imgDesktop': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'imgMobile': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'action': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'type': new FormControl(null, [Validators.required, Validators.nullValidator]),
      'page': new FormControl(null, [Validators.required, Validators.nullValidator])
    });
  }
  ngOnInit() {}
  formBanners: FormGroup;
  formEditBanners: FormGroup;
  BannerCreate = new BannerModel;
  BannerEdit = new BannerModel;
  modalRef: BsModalRef;
  isDisable: boolean = false;
  previewDesktop: any;
  previewMobile: any;
  previewCheckSetDesktop: boolean = false;
  previewCheckSetMobile: boolean = false;
  @Output() setBannerList= new EventEmitter<BannerModel[]>();
  @Input() pagination: BannerFetchData;
  @ViewChild("bannercreatemodal") createRef: ModalsComponent;
  @ViewChild("bannereditmodal") editRef: ModalsComponent;
  options = [
    {id: 1, name: BannerType[BannerType.Banner], value:BannerType.Banner},
    {id: 2, name: BannerType[BannerType.Modal], value:BannerType.Modal},
  ]

  fetchBanner() {
    this.BannerService
    .fetchBanner(this.pagination)
    .subscribe( x => {
      this.setBannerList.emit(x.bannerList);
    });
  }

  //CREATE!! - - - - - - - - - - -
  validationCreate() {
    let status:boolean;
    this.formBanners.get('name').markAsTouched();
    this.formBanners.get('imgDesktop').markAsTouched();
    this.formBanners.get('imgMobile').markAsTouched();
    this.formBanners.get('action').markAsTouched();
    this.formBanners.get('type').markAsTouched();
    this.formBanners.get('page').markAsTouched();
    status = (
      this.formBanners.get('name').invalid||
      this.formBanners.get('imgDesktop').invalid||
      this.formBanners.get('imgMobile').invalid||
      this.formBanners.get('action').invalid||
      this.formBanners.get('type').invalid||
      this.formBanners.get('page').invalid
    )
    return status;
  }

  async create() {
      if(!this.validationCreate()) {
        this.isDisable = true;
        this.BannerCreate.bannerActive = true;
        await this.BannerService.createBanner(this.BannerCreate).subscribe(x => {
          if(x) {
            this.fetchBanner();
            this.closeCreate();
          }
        });
        return;
      }
  }

  openCreate() {
      this.isDisable = false;
      this.formBanners.reset();
      this.BannerCreate = new BannerModel;
      this.modalRef = this.modalService.show(this.createRef,{
        class: 'modal-lg',
        initialState: true,
      });
  }

  closeCreate() {
      this.modalRef.hide();
  }

  changeCreateSelect(e: any) {
    this.BannerCreate.bannerType = e.value;
  }

  changeCreateFile(type:string, e:any) {
    if(type==='desktop') {
      this.previewDesktop = null;
      this.BannerCreate.bannerImageDesktop = null;
      if (e.target.files.length > 0) {
        this.BannerCreate.bannerImageDesktop = e.target.files[0];
        const file = e.target.files[0];

        if(file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = ()=> {
            this.previewDesktop = reader.result
          }
          reader.onerror = (err)=> {
            console.log("Error: ", err)
          }
        }
      }
      return;
    } else if(type==='mobile') {
      this.previewMobile = null;
      this.BannerCreate.bannerImageMobile = null;
      if (e.target.files.length > 0) {
        this.BannerCreate.bannerImageMobile = e.target.files[0];
        const file = e.target.files[0];
        if(file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = ()=> {
            this.previewMobile = reader.result
          }
          reader.onerror = (err)=> {
            console.log("Error: ", err)
          }
        }
      }
    }
  }

  //UPDATE!! - - - - - - - - - - -
  validationEdit() {
    let status:boolean;
    let imgDesktop: boolean = false;
    let imgMobile: boolean = false;
    if(this.formEditBanners.get('imgDesktop').errors) {
      if(!this.formEditBanners.get('imgDesktop').errors["required"]) {
        imgDesktop = true;
      }
    }
    if(this.formEditBanners.get('imgMobile').errors) {
      if(!this.formEditBanners.get('imgMobile').errors["required"]) {
        imgMobile = true;
      }
    }

    this.formEditBanners.get('name').markAsTouched();
    this.formEditBanners.get('imgDesktop').markAsTouched();
    this.formEditBanners.get('imgMobile').markAsTouched();
    this.formEditBanners.get('action').markAsTouched();
    this.formEditBanners.get('type').markAsTouched();
    this.formEditBanners.get('page').markAsTouched();

    status =(
      imgDesktop ||
      imgMobile ||
      this.formEditBanners.get('name').invalid||
      this.formEditBanners.get('action').invalid||
      this.formEditBanners.get('type').invalid||
      this.formEditBanners.get('page').invalid
    )
      return status;
    }

  async update() {
    if(!this.previewCheckSetDesktop) {
      this.formEditBanners.get('imgDesktop').setErrors(null);
    }
    if(!this.previewCheckSetMobile) {
      this.formEditBanners.get('imgMobile').setErrors(null);
    }
    console.log(this.formEditBanners);
    if(!this.validationEdit()) {
      this.isDisable = true;
      console.log(this.BannerEdit);
      this.BannerService.updateBanner(this.BannerEdit).subscribe(x => {
        if(x) {
          this.fetchBanner();
          this.closeEdit();
        }
      })
      return;
    }
  }

  openEdit(banner: BannerModel) {
    this.formEditBanners.reset();
    this.previewCheckSetDesktop = false;
    this.previewCheckSetMobile = false;
    this.isDisable = false;
    if(!banner) return;
    this.BannerEdit.bannerImageDesktop = null;
    this.BannerEdit.bannerImageMobile = null;
    this.previewDesktop = banner.bannerImageDesktop;
    this.previewMobile = banner.bannerImageMobile;
    this.BannerEdit.bannerId = banner.bannerId;
    this.BannerEdit.bannerName = banner.bannerName;
    this.BannerEdit.bannerActive = banner.bannerActive;
    this.BannerEdit.bannerAction = banner.bannerAction;
    this.BannerEdit.bannerPage = banner.bannerPage;
    this.BannerEdit.bannerType = banner.bannerType;
    this.BannerEdit.bannerSurrId = banner.bannerSurrId;
    this.modalRef = this.modalService.show(this.editRef,{
      class: 'modal-lg',
      initialState: true,
    })
  }

  changeEditFile(type:string, e:any) {
    if(type==='desktop') {
      this.previewCheckSetDesktop = true;
      this.previewDesktop = null;
      this.BannerEdit.bannerImageDesktop = null;
      if (e.target.files.length > 0) {
        this.BannerEdit.bannerImageDesktop = e.target.files[0];
        const file = e.target.files[0];

        if(file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = ()=> {
            this.previewDesktop = reader.result
          }
          reader.onerror = (err)=> {
            console.log("Error: ", err)
          }
        }
      }
      return;
    } else if(type==='mobile') {
      this.previewCheckSetMobile = true;
      this.previewMobile = null;
      this.BannerEdit.bannerImageMobile = null;
      if (e.target.files.length > 0) {
        this.BannerEdit.bannerImageMobile = e.target.files[0];
        const file = e.target.files[0];
        if(file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = ()=> {
            this.previewMobile = reader.result
          }
          reader.onerror = (err)=> {
            console.log("Error: ", err)
          }
        }
      }
    }
  }

  closeEdit() {
    this.modalRef.hide();
  }

  changeEditSelect(e: any) {
    this.BannerEdit.bannerType = e.value;
  }
}
